import { useState } from "react";
import { MessageImage } from "../../types/message";
import "../../Styles/Layout/Input-Area/attachmentImageCard.css";

interface ImageFileCardProps {
    image: MessageImage;
    onClick: () => void;
}

export const ImageFileCard = ({ image, onClick }: ImageFileCardProps) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    return (
        <div className="image-file-card-container"
        >
            {isLoading && !isError && (
                <div className="loading-container">
                    <span className="loader-spinner" />
                </div>
            )}
            {!isError ? (
                <img
                    src={image.url}
                    alt={image.title || ""}
                    className="image-element"
                    style={{
                        display: isLoading ? "none" : "block",
                        borderRadius: "var(--radius-xl)"
                    }}
                    onClick={onClick}
                    onLoad={() => setIsLoading(false)}
                    onError={() => {
                        setIsLoading(false);
                        setIsError(true);
                    }}
                    draggable={false}
                />
            ) : (
                <div
                    className="error-container"
                    title="Failed to load image"
                >
                    <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
                        <rect width="24" height="24" rx="12" fill="var(--background-light, #f3f3f3)"/>
                        <path d="M7 17l3.5-4.5 2.5 3 3-4 3 5H7z" fill="var(--border-secondary, #d1d5db)"/>
                        <circle cx="9" cy="10" r="1" fill="var(--text-secondary, #b0b0b0)"/>
                        <rect x="4" y="4" width="16" height="16" rx="8" stroke="var(--border-color, #e0e0e0)" strokeWidth="1"/>
                    </svg>
                </div>
            )}
        </div>
    );
}